define('app/views/dc_category_filter',['app/setup'], function(takhfifan) {
  takhfifan.DCCategoryFilter = Backbone.View.extend({
    events: {
      'click .tkh-dc-category-filter__item': 'filter'
    },

    initialize: function () {
      this.$itemsWrapper = $('.tkh-dc-category-filter__list');
      this.$sidebarWrapper = $('.tkh-fix-sidebar-custom__inner');
      this.$deals = this.$itemsWrapper.find('.tkh-dc-category-filter__deal');
      this.$items = this.$('.tkh-dc-category-filter__item');

      $('.tkh-dc-filter-column').bind('contextmenu', function(e) {
        return false;
      }); 
    },

    filter: function (e) {
      e.preventDefault();
      var $target = $(e.target),
          targetWasActive = $target.hasClass('active'),
          id = $target.data('id');

      this.$items.removeClass('active');

      if(!targetWasActive){
        this.$deals.removeClass('not-filtered');
        this.$itemsWrapper.find(".tkh-dc-category-filter__deal[data-category-ids~='"+id+"']").addClass('not-filtered');
        this.$itemsWrapper.addClass('filtered');
        $target.addClass('active');
      }else{
        this.$itemsWrapper.removeClass('filtered');
      }
      this.adjustFilterList();

      takhfifan.eventHub.trigger('lazyLoad:notify');
    },

    adjustFilterList: function () {
      if(this.$itemsWrapper.height() < this.$sidebarWrapper.height()){
        this.$sidebarWrapper.parent('.tkh-fix-sidebar-custom__side').addClass('no-sticky');
      }else{
        this.$sidebarWrapper.parent('.tkh-fix-sidebar-custom__side').removeClass('no-sticky');
        takhfifan.eventHub.trigger('sticky:update');
      }
    }


  })
});

